module.exports = __webpack_public_path__ + "img/logo.114cfadf.png";